import { render, staticRenderFns } from "./UserRegSetupSecProfComponent.vue?vue&type=template&id=9789f40c&scoped=true"
import script from "./UserRegSetupSecProfComponent.vue?vue&type=script&lang=js"
export * from "./UserRegSetupSecProfComponent.vue?vue&type=script&lang=js"
import style0 from "./UserRegSetupSecProfComponent.vue?vue&type=style&index=0&id=9789f40c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9789f40c",
  null
  
)

export default component.exports